<template>
  <div>
    {{ prefix }}{{ formattedCount }}
  </div>
</template>

<script>
export default {
  props: {
    targetCount: {
      type: Number,
      required: true,
    },
    type: {
      type: String,
      default: 'int', // Default type as integer
    },
    prefix: {
      type: String,
      default: '', // Default prefix
    },
    duration: {
      type: Number,
      default: 1200,
    },
  },
  data() {
    return {
      currentCount: 0,
    };
  },
  computed: {
    formattedCount() {
      // Ensure currentCount is treated as a number
      const value = Number(this.currentCount);
      return this.type === 'int'
        ? Math.round(value) // Round for integers
        : value.toFixed(2); // Limit to 2 decimal places for floats
    },
  },
  watch: {
    targetCount() {
      this.startCounting();
    },
  },
  methods: {
    startCounting() {
      const start = Date.now();
      const updateCount = () => {
        const elapsed = Date.now() - start;
        if (elapsed < this.duration) {
          this.currentCount = 
            (this.targetCount * elapsed) / this.duration;
          requestAnimationFrame(updateCount);
        } else {
          this.currentCount = this.targetCount;
        }
      };
      requestAnimationFrame(updateCount);
    },
  },
  mounted() {
    this.startCounting();
  },
};
</script>
